import React from 'react'
import { Link, useParams } from 'react-router-dom'
import blogPosts, { getBlogPostBySlug } from '../data/blogPosts'

const BlogPost = () => {
  const { slug } = useParams()
  const post = getBlogPostBySlug(slug)

  if (!post) {
    return (
      <div className="bg-gray-50 min-h-screen py-20 px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl rounded-2xl bg-white p-8 text-center shadow">
          <h1 className="text-2xl font-bold text-gray-900">Blog post not found</h1>
          <p className="mt-3 text-sm text-gray-600">The article you’re looking for may have been moved.</p>
          <Link
            to="/#blog"
            className="mt-6 inline-flex items-center justify-center rounded-lg bg-black px-6 py-2 text-sm font-semibold text-white hover:bg-gray-900"
          >
            Back to Blog
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      <header className="bg-white shadow-sm">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
          <Link to="/" className="text-lg font-semibold text-gray-900 hover:text-black">
            Employme Global Blog
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-0">
        <div className="mb-6">
          <Link
            to="/#blog"
            className="inline-flex items-center gap-2 text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors"
          >
            <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back to Blog
          </Link>
        </div>
        <article className="rounded-2xl bg-white shadow-lg">
          <div className="overflow-hidden rounded-t-2xl">
            <img
              src={post.heroImage}
              alt={post.title}
              className="h-72 w-full object-cover"
            />
          </div>

          <div className="p-8">
            <div className="text-sm font-semibold uppercase tracking-wide text-gray-500">
              {post.category}
            </div>
            <h1 className="mt-2 text-3xl font-bold text-gray-900">{post.title}</h1>
            <div className="mt-3 flex flex-wrap items-center gap-4 text-sm text-gray-500">
              <span>{post.date}</span>
              <span>•</span>
              <span>{post.readingTime}</span>
            </div>
            <p className="mt-6 text-lg text-gray-700">{post.summary}</p>

            <div className="mt-10 space-y-10">
              {post.sections.map(section => (
                <section key={section.heading}>
                  <h2 className="text-xl font-semibold text-gray-900">{section.heading}</h2>
                  <div className="mt-3 space-y-3 text-base leading-relaxed text-gray-700">
                    {section.paragraphs.map((paragraph, idx) => (
                      <p key={idx}>{paragraph}</p>
                    ))}
                  </div>
                </section>
              ))}
            </div>

            <div className="mt-10 rounded-xl bg-gray-50 p-6 text-gray-700">
              <p>{post.conclusion}</p>
            </div>
          </div>
        </article>
      </main>
    </div>
  )
}

export default BlogPost


